const MAINTENANCE_START = new Date("2025-08-27T00:00:00"); // 시작
const MAINTENANCE_END = new Date("2025-08-27T23:00:00"); // 종료
// ✅ 현재가 점검 시간 내인지 판단
const now = new Date();
export const isServiceDown = now >= MAINTENANCE_START && now < MAINTENANCE_END;

// MODAL CNTROLER.
export const CONST_COMM_MODAL_CONTROL = "constCommModalControl";

//ALERT CONTROLER
export const CONST_COMM_ALERT_CONTROL = "constCommAlerControl";

//LOADING CONTROLER
export const CONST_COMM_LOAD_CONTROL = "constCommLoadControl";

//SESSION TIME OUT
export const CONST_COMN_SESSION_TIME_OUT = "constComnSessionTimeOut";
